<template>
  <div>
    <person :model="model">
      <div class="row form-group">
        <w-datepicker class="col-6" :model="model.birthDate" />
      </div>
    </person>

    <div class="row form-group">
      <yes-or-no class="col-12" :model="model.isDifferentAddress" />
    </div>

    <div v-if="model.$model.isDifferentAddress" class="row form-group mt-3">
      <w-input class="col-12" :model="model.workName" />
    </div>

    <address-row v-if="model.$model.isDifferentAddress" :model="model.workAddress" />

    <w-radio-list class="form-group mt-3" :model="model.profesion" :values="typeOfProfesion" />

    <div class="row form-group">
      <w-input class="col-12" :model="model.profesionName" />
    </div>

    <div class="row form-group">
      <w-datepicker class="col-4" :model="model.contractDate" />

      <w-datepicker class="col-4" :model="model.contractDataStart" />

      <w-datepicker class="col-4" position="bottom-left" :model="model.contractDataEnd" />
    </div>
  </div>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';
import AddressRow from './Address';
import Person from './Person';
import YesOrNo from './YesOrNoRadio';

// @vuese
// Employee component
// @Group formComponents
export default {
  components: {
    AddressRow,
    Person,
    YesOrNo
  },
  mixins: [componentMixin],
  props: {
    // Typy profesji
    typeOfProfesion: { type: Array, required: true }
  }
};
</script>
